export const CATEGORIES = [
  { label: "Deloitte data", value: "Deloitte data" },
  { label: "Client data", value: "Client data" },
  { label: "Third-party data", value: "Third-party data" },
];
export const MAX_METADATA_LENGTH = 500;
export enum AlertColor {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}

export const KB_SOURCE = "knowledgebase";
export const TEAMS_SOURCE = "teams";
export const MAX_TXT_CHARACTERS = 1_000_000; // 1 million characters

export type SortOrder = "ascending" | "descending" | "";
export const TYPE_FOLDER = "folder";
export const TYPE_FILE = "file";
export const FOLDER_SOURCE_TEAMS = "teams";
export const INDEXING_STATUSES = {
  IN_PROGRESS: "Processing",
  SUCCESS: "Success",
  NOT_FOUND: "Not Found",
  ERROR: "Error",
} as const;
export const MAX_FILES_SIZE = 100;
export const MAX_FILE_UPLOAD = 25;
export const OVERRIDE_MESSAGE = `This file already exists, uploading will override the current version.`;
export const SOURCE_MANUAL = "Manual Upload";
export const SOURCE_TEAMS = "Teams Import";

export const SUMMARY_STATUS_SUCCESS = "success";
export const SUMMARY_STATUS_FAILED = "failed";
export const FILE_TYPE_NO_CONVERSION = ["pdf", "xls", "xlsx", "csv"];
